import React from "react";

type BaseInputProps = {
    label?: string;
    error?: string;
    multiline?: boolean;
    className?: string;
} & React.InputHTMLAttributes<HTMLInputElement> &
    React.TextareaHTMLAttributes<HTMLTextAreaElement>;

const TextInput = ({
    label,
    error,
    multiline = false,
    className = "",
    ...props
}: BaseInputProps) => {
    const inputClasses =
        "px-4 py-4 rounded-md border border-border focus:shadow-inside focus:bg-cloud-tint focus:outline-none bg-white text-black disabled:cursor-not-allowed disabled:opacity-30 transition w-full " +
        className;

    return (
        <div className="space-y-2 flex flex-col w-full">
            {label && (
                <label>
                    {label}
                </label>
            )}
            {multiline ? (
                <textarea
                    {...(props as React.TextareaHTMLAttributes<HTMLTextAreaElement>)}
                    className={`${inputClasses} min-h-[48px]`}
                    aria-label={label}
                />
            ) : (
                <input
                    {...(props as React.InputHTMLAttributes<HTMLInputElement>)}
                    className={inputClasses}
                    aria-label={label}
                />
            )}
            {error ? (
                <small className="text-warning">{error}</small>
            ) : (
                <small className="text-transparent">{" "}</small>
            )}
        </div>
    );
};

export default TextInput;
